var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusNaoParticipa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "status-nao-participa",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1044",
    "data-name": "Grupo 1044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1043",
    "data-name": "Grupo 1043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1543",
    "data-name": "Caminho 1543",
    d: "M7.5,0A7.5,7.5,0,1,0,15,7.5,7.5,7.5,0,0,0,7.5,0Zm0,14A6.5,6.5,0,1,1,14,7.5,6.507,6.507,0,0,1,7.5,14Z",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1046",
    "data-name": "Grupo 1046",
    transform: "translate(4.303 4.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1045",
    "data-name": "Grupo 1045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1544",
    "data-name": "Caminho 1544",
    d: "M150.783,150.075l2.343-2.343a.5.5,0,0,0-.707-.707l-2.343,2.343-2.343-2.343a.5.5,0,0,0-.707.707l2.343,2.343-2.343,2.343a.5.5,0,0,0,.707.707l2.343-2.343,2.343,2.343a.5.5,0,0,0,.707-.707Z",
    transform: "translate(-146.879 -146.878)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusNaoParticipa);
export default __webpack_public_path__ + "static/media/status-nao-participa.5898726d7ed7e1e6ce394420b61d8286.svg";
export { ForwardRef as ReactComponent };